/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface EmbeddingData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_EmbeddingData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_EmbeddingData_dataset")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface EmbeddingData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof EmbeddingData
        
        
    * @pattern_EmbeddingData_id
         */
    id: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof EmbeddingData
        
        
    * @pattern_EmbeddingData_dataset
         */
    dataset: string;
    /**
     *
     * #type string
     * #memberof EmbeddingData
        
        
         */
    name: string;
}
/**
 * Check if a given object implements the EmbeddingData interface.
 */
export function instanceOfEmbeddingData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "dataset" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const EmbeddingDataTypiaAssertEquals = (input: any) => {
    return ((input: any): EmbeddingData => {
        const __is = (input: any, _exceptionable: boolean = true): input is EmbeddingData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_EmbeddingData_id", "string", "", input.id) && ("string" === typeof input.dataset && $is_custom("pattern_EmbeddingData_dataset", "string", "", input.dataset)) && "string" === typeof input.name && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "dataset", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is EmbeddingData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_EmbeddingData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_EmbeddingData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.dataset && ($is_custom("pattern_EmbeddingData_dataset", "string", "", input.dataset) || $guard(_exceptionable, {
                    path: _path + ".dataset",
                    expected: "string (@pattern_EmbeddingData_dataset)",
                    value: input.dataset
                })) || $guard(_exceptionable, {
                    path: _path + ".dataset",
                    expected: "string",
                    value: input.dataset
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "dataset", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "EmbeddingData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "EmbeddingData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const EmbeddingDataTypiaAssertStringify = (input: EmbeddingData): string => {
    return ((input: any): string => { const assert = (input: any): EmbeddingData => {
        const __is = (input: any): input is EmbeddingData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).id && $is_custom("pattern_EmbeddingData_id", "string", "", (input as any).id) && ("string" === typeof (input as any).dataset && $is_custom("pattern_EmbeddingData_dataset", "string", "", (input as any).dataset)) && "string" === typeof (input as any).name);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is EmbeddingData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_EmbeddingData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_EmbeddingData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.dataset && ($is_custom("pattern_EmbeddingData_dataset", "string", "", input.dataset) || $guard(_exceptionable, {
                    path: _path + ".dataset",
                    expected: "string (@pattern_EmbeddingData_dataset)",
                    value: input.dataset
                })) || $guard(_exceptionable, {
                    path: _path + ".dataset",
                    expected: "string",
                    value: input.dataset
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "EmbeddingData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "EmbeddingData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: EmbeddingData): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"id":${$string((input as any).id)},"dataset":${$string((input as any).dataset)},"name":${$string((input as any).name)}}`;
    }; return stringify(assert(input)); })(input);
};
export const EmbeddingDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'dataset': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'name': yup.string().defined(),
};
export const EmbeddingDataValidator = yup.object().shape(EmbeddingDataValidatorShape);
export const EmbeddingDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'dataset': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'name': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const EmbeddingDataStringifyShape: ObjectSchema = {
    title: 'EmbeddingData Stringifier',
    type: 'object',
    properties: {
        ...EmbeddingDataStringifyShapeProperties
    },
    required: [
        'id',
        'dataset',
        'name',
    ],
};
export const EmbeddingDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(EmbeddingDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const EmbeddingDataStringify: (data: EmbeddingData) => string = EmbeddingDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function EmbeddingDataFromJSON(json: any): EmbeddingData {
    return EmbeddingDataFromJSONTyped(json, false);
}
export function EmbeddingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmbeddingData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'dataset': json['dataset'],
        'name': json['name'],
    };
}
export function EmbeddingDataToJSON(value?: EmbeddingData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'dataset': value.dataset,
        'name': value.name,
    };
}
